export enum ForgotPasswordPositionEnum {
    ABOVE_BUTTON = "ABOVE_BUTTON",
    BELOW_BUTTON = "BELOW_BUTTON"
}
